// extracted by mini-css-extract-plugin
export default {"cls1":"PaperAbstract-cls1___de27082794734e7e778","cls2":"PaperAbstract-cls2___55c5357f264acf20dab PaperAbstract-cls1___de27082794734e7e778"};